import React from "react";
import { Form, Formik } from "formik";
import { useOnSubmitFormik } from "api/hooks/useOnSubmitFormik";
import { Collections } from "api/model/Collections";
import * as Yup from "yup";
import { Box, Button, Divider, Grid } from "@material-ui/core";
import { SubmitButton } from "ui/componentes/SubmitButton";
import {
    PointsByRaceConfiguration,
    PointsByRaceConfigurationFormDefault,
} from "api/model/PointsByRaceConfiguration";
import { useHistory, useParams } from "react-router";
import { useCollection } from "api/hooks/useCollection";
import { PageLayout } from "ui/componentes/PageLayout";
import { InputFieldFormik } from "ui/componentes/Form/InputFieldFormik";
import {
    yupMaxLengthField,
    yupRequiredField,
} from "ui/componentes/Form/functions";
import { PointsByPositionList } from "ui/views/PointsByRaceView/PointsByPositionList";

export const PointsByRaceFormValidation = Yup.object().shape({
    name: Yup.string().required(yupRequiredField).max(100, yupMaxLengthField),
});

const PointsByRaceForm = () => {
    const { id } = useParams<{ id?: string }>();
    const history = useHistory();
    const pointsByRace: PointsByRaceConfiguration =
        useCollection<PointsByRaceConfiguration>({
            collection: Collections.POINTS_BY_RACE_CONFIG,
            doc: id || "-1",
        }) || PointsByRaceConfigurationFormDefault;

    const onSubmit = useOnSubmitFormik<PointsByRaceConfiguration>(
        Collections.POINTS_BY_RACE_CONFIG,
        {
            callback: (id) => {
                if (pointsByRace && !pointsByRace.id) {
                    history.push(`/points-by-race-config/${id}`);
                }
            },
        }
    );

    return (
        <Formik
            enableReinitialize={true}
            initialValues={pointsByRace}
            onSubmit={onSubmit}
            validationSchema={PointsByRaceFormValidation}
        >
            {({ values }) => {
                return (
                    <PageLayout
                        title={`${
                            id ? "Editando" : "Adicionando"
                        } configuração - (${values.name})`}
                    >
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Form>
                                    <Grid item xs={6}>
                                        <InputFieldFormik
                                            id="name"
                                            name="name"
                                            label="Nome"
                                        />
                                    </Grid>
                                    <Grid item xs={6} />
                                    <Grid item xs={12}>
                                        <Box display="flex">
                                            <SubmitButton fullWidth={false}>
                                                {`Salvar`}
                                            </SubmitButton>
                                            <Button
                                                style={{
                                                    marginLeft: 5,
                                                }}
                                                fullWidth={false}
                                                onClick={() =>
                                                    history.push(
                                                        "/points-by-race-configs"
                                                    )
                                                }
                                            >
                                                Voltar
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Form>
                            </Grid>
                            {pointsByRace.id && (
                                <Grid item xs={12}>
                                    Pontuações
                                </Grid>
                            )}
                            {pointsByRace.id && (
                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                            )}
                            {pointsByRace.id && (
                                <Grid item xs={12}>
                                    <PointsByPositionList
                                        pointsByRace={pointsByRace}
                                    />
                                </Grid>
                            )}
                        </Grid>
                    </PageLayout>
                );
            }}
        </Formik>
    );
};

export { PointsByRaceForm };
